module.exports = __webpack_public_path__ + "img/no_img_available.542c1d33.png";